import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
const db = firebase.firestore()

const state = {
  applicationStatuses: [
    { text: 'Created', value: 'created' },
    { text: 'Collecting documents', value: 'collecting' },
    { text: 'In progress', value: 'inProgress' },
    { text: 'To check', value: 'toCheck' },
    { text: 'Sent to applicant', value: 'sentToApplicant' },
    { text: 'Complete', value: 'complete' },
    { text: 'Submitted', value: 'submitted' }
  ],
  body: [],
  bodyComponents: [],
  bodyCategories: []
}

const actions = {
  GET_SINGLE_BODY ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      let bodies = []
      db.collection('bodies')
        .doc(slug)
        .get()
        .then((doc) => {
          if (doc) {
            bodies.push(doc.data())
            commit('SET_LOADED_BODY', bodies[0])
            resolve(doc)
          }
        })
        .catch(reject)
    })
  },
  CREATE_BODY_CATEGORY ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('bodies')
        .doc(payload.bodySlug)
        .collection('categories')
        .doc(String(payload.bodyClass.slug))
        .set(payload.bodyClass)
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  UPDATE_BODY_CATEGORY ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.bodyClass
      db.collection('bodies')
        .doc(payload.bodySlug)
        .collection('categories')
        .doc(String(payload.bodyClass.slug))
        .update({
          title: data.title,
          createdAt: data.createdAt,
          slug: data.slug,
          isActive: data.isActive,
          icon: data.icon,
          body: data.body
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  ADD_BODY_REQUIREMENT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('bodies')
        .doc(payload.bodySlug)
        .update({
          requirements: firebase.firestore.FieldValue.arrayUnion(payload.bodyRequirement)
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  UPDATE_BODY_REQUIREMENT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('bodies')
        .doc(payload.bodySlug)
        .update({
          requirements: payload.requirements
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  GET_BODY_CATEGORIES ({ commit }, slug) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('bodies').doc(slug).collection('categories')
      let unsub = ref.onSnapshot(snapshot => {
        let bodyCategories = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          bodyCategories.push(log)
        })
        commit('SET_LOADED_CATEGORIES', bodyCategories)
      }, (error) => {
        reject(error)
      })
      resolve(unsub)
    })
  },
  GET_SINGLE_BODY_COMPONENTS ({ commit }, slug) {
    let resolved = false
    return new Promise((resolve, reject) => {
      let ref = db.collection('bodies').doc(slug).collection('categories')
      ref.onSnapshot(async snapshot => {
        try {
          let bodyComponents = []
          const promises = snapshot.docs.map(doc => {
            return db.collection('bodies')
              .doc(slug)
              .collection('categories')
              .doc(doc.data().slug)
              .collection('components')
              .get()
          })
          const results = await Promise.all(promises)
          results.forEach(snap => {
            snap.forEach(doc2 => {
              bodyComponents.push({
                id: doc2.id,
                ...doc2.data()
              })
            })
          })
          commit('SET_LOADED_COMPONENTS', bodyComponents)
          if (!resolved) {
            resolved = true
            resolve()
          }
        } catch (error) {
          reject(error)
        }
      }, (error) => {
        reject(error)
      })
    })
  },
  UPDATE_SINGLE_BODY_COMPONENT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = payload.bodyComponent
      db.collection('bodies')
        .doc(data.body)
        .collection('categories')
        .doc(String(data.category))
        .collection('components')
        .doc(String(data.id))
        .update({
          title: data.title,
          slug: data.slug,
          isActive: data.isActive,
          css: data.css,
          code: data.code,
          isPaid: data.isPaid
        })
        .then(snapshot => {
          resolve(snapshot)
        })
        .catch(reject)
    })
  },
  ADD_SINGLE_BODY_COMPONENT ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('bodies')
        .doc(payload.bodySlug)
        .collection('categories')
        .doc(String(payload.bodyClass.slug))
        .collection('components')
        .add(payload.bodyComponent)
        .then(snapshot => {
          let componentId = snapshot.id
          db.collection('bodies')
            .doc(payload.bodySlug)
            .collection('categories')
            .doc(String(payload.bodyClass.slug))
            .collection('components')
            .doc(componentId)
            .update({
              id: componentId
            })
            .then(snapshot => {
              resolve(snapshot)
            })
            .catch(reject)
        })
        .catch(reject)
    })
  }
}

const getters = {
}

const mutations = {
  SET_LOADED_BODY (state, payload) {
    state.body = payload
  },
  SET_LOADED_COMPONENTS (state, payload) {
    state.bodyComponents = payload
  },
  SET_LOADED_CATEGORIES (state, payload) {
    state.bodyCategories = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
